<template>
  <div>
    <div class="resBox" v-if="auditList.length > 0">
      <div class="header">
        <xrk-subtitle>
          <span style="color:#333">审核状态</span>
        </xrk-subtitle>
        <span></span>
        <div>
          <div
            @click="expandFlag = !expandFlag"
            class="expandBox"
            v-if="leftArr.length > 0"
          >
            {{ expandFlag ? '展开' : '收起' }}
            <i
              :class="[expandFlag ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"
            ></i>
          </div>
        </div>
      </div>
      <div
        class="liBox"
        :class="typeMap[auditStatus(firstObj)].className + 'Bg'"
        ref="firstBox"
      >
        <div class="liBox-first">
          <i
            :class="[
              typeMap[auditStatus(firstObj)].icon,
              typeMap[auditStatus(firstObj)].className
            ]"
            class="icon"
          ></i>
          <div class="liBox-first-right">
            <div style="margin-bottom:12px;">
              {{ typeMap[auditStatus(firstObj)].title }}
            </div>
            <div style="font-size:12px;line-height:12px;">
              <span class="top" style="margin-right:48px;">
                提交时间：{{ firstObj.createDt | transAllTime }}
              </span>
              <span class="btm">
                审核时间：{{ firstObj.auditDt | transAllTime }}
              </span>
            </div>
          </div>
        </div>
        <template v-if="auditStatus(firstObj) === 2">
          <div class="liBox-last">
            <div style="flex:3">审核不通过原因：</div>
            <div style="flex:17;">{{ firstObj.auditRemark }}</div>
          </div>
          <div class="liBox-last" v-if="noPassRemark">
            <div style="flex:20">{{ noPassRemark }}</div>
          </div>
        </template>
      </div>
      <el-collapse-transition>
        <div v-show="!expandFlag" class="abBox" ref="abBox">
          <div
            v-for="(item, index) in leftArr"
            class="liBox"
            :class="typeMap[auditStatus(item)].className + 'Bg'"
            :key="index"
          >
            <div class="liBox-first">
              <i
                :class="[
                  typeMap[auditStatus(item)].icon,
                  typeMap[auditStatus(item)].className
                ]"
                class="icon"
              ></i>
              <div class="liBox-first-right">
                <div style="margin-bottom:12px;">
                  {{ typeMap[auditStatus(item)].title }}
                </div>
                <div style="font-size:12px;line-height:12px;">
                  <span class="top" style="margin-right:48px;">
                    提交时间：{{ item.createDt | transAllTime }}
                  </span>
                  <span class="btm">
                    审核时间：{{ item.auditDt | transAllTime }}
                  </span>
                </div>
              </div>
            </div>
            <div class="liBox-last" v-if="auditStatus(item) === 2">
              <div style="flex:3">审核不通过原因：</div>
              <div style="flex:17;">{{ item.auditRemark }}</div>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>
<script>
import XrkSubtitle from '@C/XrkSubtitle';
import createExtend from '@C/createExtend';
import BusinessDescription from './BusinessDescription';
import { bizDesc } from '@/api/ajax';

export default {
  components: { XrkSubtitle },
  props: {
    projectStatus: {
      type: Number | String
    },
    auditList: {
      type: Array
    },
    // 额外的不通过信息，使用场景为问卷
    noPassRemark: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      expandFlag: true,
      returnList: [],
      typeMap: {
        0: {
          icon: 'el-icon-warning',
          title: '项目未提交审核',
          className: 'warning'
        },
        1: {
          icon: 'el-icon-info',
          title: '项目审核中',
          className: 'primary'
        },
        2: {
          icon: 'el-icon-error',
          title: '项目审核不通过',
          className: 'danger'
        },
        3: {
          icon: 'el-icon-success',
          title: '项目审核通过',
          className: 'success'
        }
      },
      businessDesc: {}
    };
  },
  computed: {
    projectId() {
      return this.$store.state.homeProject.id;
    },
    firstObj() {
      return this.auditList.length > 0 ? this.auditList[0] : {};
    },
    leftArr() {
      return this.auditList.length > 1 ? this.auditList.slice(1) : [];
    },
    auditStatus() {
      return auditInfo => {
        // {
        //   projectStatus //项目状态  0 乙方待编辑  1  乙方编辑完成   2 甲方待确认   3 甲方编辑完成
        //   auditStatus //审核状态  0 未提交审核  1 审核中  2 审核未通过  3  审核通过
        // }
        const { projectStatus } = this;
        const { auditStatus } = auditInfo;
        // 根据审核阶段 和 审核状态计算乙方应该显示的审核状态
        let realStatus = +auditStatus;

        if ([1, 2].includes(+projectStatus) && auditStatus == 3) {
          // 审核阶段没有到甲方编辑完成，但是审核状态已经是审核通过的情况
          // 理论上不会出现这类的数据
          // 强行把状态修改为审核中
          realStatus = 1;
        }
        if (projectStatus == 2) {
          // 甲方待确认，乙方始终为审核中状态
          realStatus = 1;
        }
        if (projectStatus == 3 && auditStatus != 3) {
          // 甲方已确认，但oss未审核或者审核未通过，乙方始终为审核中状态
          realStatus = 1;
        }
        return realStatus;
      };
    }
  },
  watch: {
    expandFlag() {
      let h = this.$refs.firstBox.offsetHeight;
      this.$refs.abBox.style.top = h + 65 + 'px';
    }
  },
  methods: {
    explainShow() {
      createExtend(BusinessDescription, {
        businessDesc: this.businessDesc.info
      });
    }
  },
  async created() {
    const { pdata } = await bizDesc({ projectId: this.projectId });
    this.businessDesc = pdata;
  }
};
</script>
<style lang="scss" scoped>
$--color-primary: #909399;
$--color-success: #65c137;
$--color-warning: #e6a23c;
$--color-danger: #ff4949;

.explainBox {
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 1;
  display: flex;
  align-items: center;
  color: #606266;
  margin-bottom: 12px;
  cursor: pointer;
  margin: 0 12px 12px 0;
  span {
    margin-right: 5px;
  }
}
.resBox {
  position: relative;
  //width: 85vw;
  .header {
    padding-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1989fa;
    font-size: 14px;
    font-weight: 500;
    .editTitle {
      color: #000;
    }
    .expandBox {
      margin: 40px 20px 0 0;
      cursor: pointer;
    }
  }
  .primaryBg {
    background: #f0f2f5;
    color: $--color-primary;
  }
  .warningBg {
    background: #fdf5e6;
    color: $--color-warning;
  }
  .successBg {
    background: #f0f9ea;
    color: $--color-success;
  }
  .dangerBg {
    background: #fef0f0;
    color: $--color-danger;
  }
  .abBox {
    position: absolute;
    top: 164px;
    z-index: 10;
    max-height: 472px;
    overflow-y: scroll;
    width: 100%;
  }
  .liBox {
    //width: 820px;
    padding: 16px;
    //margin-left: 20px;
    border-radius: 4px;
    margin-bottom: 8px;
    i {
      font-size: 24px;
    }
    .primary {
      color: $--color-primary;
    }
    .success {
      color: $--color-success;
    }
    .warning {
      color: $--color-warning;
    }
    .danger {
      color: $--color-danger;
    }
    &-first {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 14px;
      &-right {
        margin-left: 8px;
      }
    }
    &-last {
      margin-left: 32px;
      display: flex;
      justify-content: flex-start;
      font-size: 12px;
      line-height: 20px;
      margin-top: 8px;
    }
  }
}
</style>
